import { isObject } from '../lang';
import forEach from './forEach';
export default function mapValues(obj, cb) {
    if (!isObject(obj)) {
        return {};
    }
    const mappedObject = {};
    forEach(obj, (value, key) => {
        mappedObject[key] = cb(value, key);
    });
    return mappedObject;
}
